import type { UserQuantities } from '@/types'
import { request } from './client'

export async function getUserQuantities(): Promise<UserQuantities> {
  return request<UserQuantities>('/user/quantities')
}
